<template>
  <v-form v-model="valid" ref="DialogForm">
    <slotted-dialog :title="$t('servicesystem.common_objects.machine.merge_machines_title')"
      :externaltrigger="dialogtrigger" :external-close-trigger="closetrigger">

      <template v-slot:content>
        <v-container :key="dialogtrigger">
          <v-alert type="info" prominent dense class="mb-4">
            {{ $t('servicesystem.common_objects.machine.merge_machines_info') }}
          </v-alert>
          <v-row align="center" no-gutters class="mb-4">
            <v-col cols="0">
              <h6>{{ $t('servicesystem.common_objects.commonterms.on') }}</h6>
              <v-card width="fit-content" class="px-2 py-1" color="primary" dark flat>
                {{ $t('servicesystem.common_objects.machine.selected_machines') }}
              </v-card>
            </v-col>
          </v-row>
          <v-row align="center" no-gutters class="mb-4">
            <v-col>
              <h6>Filter target options by customer</h6>
              <CustomerSelect v-model="customerId" externaledit clearable disableAttach
                :placeholder="$t('servicesystem.common_objects.customer.search_field_label')">
              </CustomerSelect>
            </v-col>
          </v-row>
          <v-row align="center" no-gutters class="mb-10">
            <v-col>
              <h6>Target</h6>
              <MachineSelect v-model="toMachineId" :filter="machineFilter" externaledit clearable disableAttach
                :placeholder="$t('servicesystem.common_objects.machine.search_field_label')" returnobject>
              </MachineSelect>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:buttons>
        <v-btn @click="closetrigger++" color="primary" outlined
          v-text="$t('servicesystem.common_objects.commonterms.cancel')">
        </v-btn>
        <v-btn :loading="loading" :disabled="!toMachineId" color="primary" dark
          @click="toMachineId && !loading ? save() : null">
          {{ $t('servicesystem.common_objects.machine.merge_machines_btn') }}
        </v-btn>
      </template>
    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";
import MachineSelect from "@/components/Inputs/EntityDropdowns/MachineSelect2.vue";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";

export default {
  name: "MergeMachinesDialog",
  props: {
    externaltrigger: Number,
    currentCustomerId: String,
    saveFunction: {
      type: Function,
      required: true,
    },
  },
  components: {
    SlottedDialog,
    CustomerSelect,
    MachineSelect,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
      customerId: null,
      toMachineId: null,
      valid: false,
      loading: false,
    };
  },

  computed: {
    machineFilter() {
      if (!this.customerId) return {};
      return { CustomerId: this.customerId };
    },
  },

  methods: {
    async save() {
      const targetId = this.toMachineId?.Id ?? this.toMachineId;
      if (!targetId) return;
      this.loading = true;
      await this.saveFunction(targetId)
        .then(() => {
          this.closetrigger++;
        })
        .catch(() => { })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  watch: {
    externaltrigger: function () {
      this.customerId = this.currentCustomerId || null;
      this.toMachineId = null;
      this.dialogtrigger++;
    },
  },
};
</script>
